import React, { useEffect, useMemo, useState } from 'react';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import { history, useDispatch, useIntl } from 'umi';
import {
  PC_CONSOLE_TOP_CHARTS_VARIANTS,
  PC_CONSOLE_TOP_CHARTS_VARIANT_IDS,
} from '@intelligence/pages/TopCharts/PCConsoleGames/variants';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import '@/pages/intelligence/assets/scss/TopCharts/PCConsoleGames/tabTitle.scss';

const { Content } = Layout;

const METRICS_TABLE_TAB_ID = 'MetricsTable';

const AVAILABLE_TABS = PC_CONSOLE_TOP_CHARTS_VARIANT_IDS;

const PCConsoleGames: React.FC<any> = ({ match, isStudio }) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const initialTab = useMemo(() => {
    const routeTab = match?.params?.tab;
    return AVAILABLE_TABS.includes(routeTab) ? routeTab : METRICS_TABLE_TAB_ID;
  }, [match?.params?.tab]);

  const [activeId, setActiveId] = useState(initialTab);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const routeTab = match?.params?.tab;
    if (routeTab && AVAILABLE_TABS.includes(routeTab) && routeTab !== activeId) {
      setActiveId(routeTab);
    }
  }, [match?.params?.tab, activeId]);

  useEffect(() => {
    if (!isStudio && (!match?.params?.tab || !AVAILABLE_TABS.includes(match.params.tab))) {
      history.replace(`/intelligence/topCharts/pcConsoleGames/${activeId}`);
    }
    // if(isStudio && gameCode && !AVAILABLE_TABS.includes(activeId) && studioId) {
    //   history.replace(`/studio/${studioId}/${gameCode}/intelligence/topCharts/${activeId}`);
    // }
  }, [activeId, match?.params?.tab, isStudio]);

  const tabs = useMemo(
    () =>
      PC_CONSOLE_TOP_CHARTS_VARIANTS.map(({ id, labelId, renderLabel, Component }) => ({
        id,
        label: renderLabel ? renderLabel(formatMessage) : formatMessage({ id: labelId }),
        Component,
      })),
    [formatMessage],
  );

  return (
    <Content className="dbi-topcharts-pc pc-console-topcharts dbi-topcharts-list">
      <Content.Header
        className="contentHead-normal"
        title={
          <div className="dbi-topcharts-pc__header-title">
            <div className="dbi-topcharts-pc__header-title-left">{formatMessage({ id: 'dbi_pcconsole_games' })}</div>
          </div>
        }
      >
        <div className="header-tab">
          <Tabs
            ceiling
            animated={false}
            tabs={tabs.map(({ id, label }) => ({ id, label }))}
            activeId={activeId}
            newMarkIdsMappingKey="TopChartsPCConsoleGames"
            onActive={(tab) => {
              const nextId = tab?.id || METRICS_TABLE_TAB_ID;
              if (nextId === activeId) return;
              setActiveId(nextId);
              dispatch({ type: `${DBI_TOPCHARTS}/setMetricValue`, payload: '' });
              dispatch({ type: `${DBI_TOPCHARTS}/setMetricCurName`, payload: '' });
              if (!isStudio) {
                history.replace(`/intelligence/topCharts/pcConsoleGames/${nextId}`);
              }

              // if(isStudio) {
              //   history.replace(`/studio/${studioId}/${gameCode}/intelligence/topCharts/${nextId}`);
              // }
              setLoading(true);
              setTimeout(() => {
                setLoading(false);
              }, 0);
            }}
          />
        </div>
      </Content.Header>
      <Content.Body full className="pc-console-topcharts__body">
        {!loading &&
          (() => {
            const activeTab = tabs.find(({ id }) => id === activeId);
            if (!activeTab) return null;
            const ActiveComponent = activeTab?.Component;
            return (
              <div key={activeTab?.id}>
                <ActiveComponent />
              </div>
            );
          })()}
      </Content.Body>
    </Content>
  );
};

export default PCConsoleGames;
